import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '../Icon/Icon';

import { Props } from './Reviews.model';
import userScoreHelper, { Score } from '../../Helpers/useScoreHelper';

import styles from './Reviews.module.scss';

const Reviews = ({ onClickReviewer, reviews }: Props) => {
	const { getScoreByRating } = userScoreHelper();
	const intl = useIntl();

	return (
		<div className={styles.wrapper}>
			{reviews?.length ? reviews.map(({ feedback, rating, reviewer }, index: number) => {
				const score = getScoreByRating(rating);

				return (
					<div className={styles.review} key={`review${index}`}>
						<div className={`${styles.score} ${styles[score]}`}>
							{score === Score.Substandard && <Icon height="24px" name="bad-star" type="custom" width="24px" />}
							{score === Score.Good && <Icon height="20px" name="star" type="solid" width="20px" />}
							{score === Score.Exceptional && <Icon height="20px"name="stars" type="solid" width="20px" />}
							<h3><FormattedMessage id={`ratings.score.${score}`} /></h3>
						</div>
						<p>{feedback}</p>
						<div className={styles.reviewer}>
							<div className={styles.avatar} onClick={() => onClickReviewer && onClickReviewer(reviewer.userId)}>
								{reviewer.imageId && !reviewer.isDeleted ? <img alt="Avatar" src={reviewer.imageId}/> : <Icon name="user" width="16px" color="white" />}
							</div>
							<span onClick={() => onClickReviewer && onClickReviewer(reviewer.userId)}>{!reviewer.isDeleted ? reviewer.name : intl.formatMessage({id: "userLabels.deletedUser"})}</span>
						</div>
					</div>
				);
			}) : <div><FormattedMessage id="userLabels.placeholder" /></div>}
		</div>
	);

}

export default Reviews;
